import React from "react";
import "../../styles/App.scss";
import { Button, Input, Row } from "react-materialize";
import { LeftButton } from "../../components/buttons/LeftButton";
import { FinaerSelect } from "../elements/Select";
import { idDocuments } from "../../lib/idDocuments";
import IdNumberValidator from "../../models/IdNumberValidator";
import CreateWarrantyLeadWizardStep from "./CreateWarrantyLeadWizardStep";
import { registerGoogleTagManagerEvent } from "../../lib/googleTagManager";

export default class CreateWarrantyLeadWizardStepTwo extends CreateWarrantyLeadWizardStep {
  constructor(props) {
    super(props);
    this.handleInputChange = this.handleInputChange.bind(this);

    this.handleIdNumberChange = this.handleIdNumberChange.bind(this);
    this.handleIdTypeChange = this.handleIdTypeChange.bind(this);
    this.handlePhoneAreaCodeChange = this.handlePhoneAreaCodeChange.bind(this);
    this.handlePhoneNumberChange = this.handlePhoneNumberChange.bind(this);

    this._form = React.createRef();
  }

  // Validating
  _requiredFields(application) {
    return ["idType", "idNumber", "phoneAreaCode", "phoneNumber"];
  }

  _areValidLeadFields(leadFields) {
    return this.form().checkValidity() && !this.hasErrorsIn(leadFields);
  }

  // Errors
  _errorMessageIfIdNumberIsInvalid(idNumber, leadFields) {
    const idType = leadFields.idType.value;
    let validator = IdNumberValidator.NewFor(idType, idNumber);
    return validator.validate();
  }

  _errorMessageForPhoneAreaCode(value) {
    if (value && value.length < 2)
      return "El código de área debe tener al menos 2 dígitos";
    return "";
  }

  _errorMessageForPhoneNumber(value) {
    if (value === "")
      return "El número de teléfono debe tener al menos 6 dígitos";
    if (value && value.length < 6)
      return "El número de teléfono debe tener al menos 6 dígitos";
    return "";
  }

  // Convenience
  form() {
    return this._form.current;
  }

  _idNumberFieldWith(newIdNumber, leadFields) {
    return {
      value: newIdNumber,
      error: this._errorMessageIfIdNumberIsInvalid(newIdNumber, leadFields),
    };
  }

  // Event handling
  handleIdTypeChange(event) {
    let leadFields = { ...this.state.leadFields };
    leadFields["idType"] = { value: event.target.value };
    let idNumber = leadFields.idNumber.value;
    leadFields["idNumber"] = this._idNumberFieldWith(idNumber, leadFields);
    this.updateLeadFieldsStateWith(leadFields);
  }

  handleIdNumberChange(event) {
    let leadFields = { ...this.state.leadFields };
    let newIdNumber = event.target.value;
    leadFields["idNumber"] = this._idNumberFieldWith(newIdNumber, leadFields);
    this.updateLeadFieldsStateWith(leadFields);
  }

  handlePhoneAreaCodeChange(event) {
    let leadFields = { ...this.state.leadFields };
    const value = event.target.value;
    leadFields.phoneAreaCode = {
      value,
      error: this._errorMessageForPhoneAreaCode(value),
    };
    this.updateLeadFieldsStateWith(leadFields);
  }

  handlePhoneNumberChange(event) {
    let leadFields = { ...this.state.leadFields };
    const value = event.target.value;
    leadFields.phoneNumber = {
      value,
      error: this._errorMessageForPhoneNumber(value),
    };
    this.updateLeadFieldsStateWith(leadFields);
  }

  nextButtonPressed(event) {
    super.nextButtonPressed(event);
    registerGoogleTagManagerEvent({
      event: "Paso_2_Avanzar_Para_Terminar",
      event_category: "Finaer",
      event_label: "",
    });
    this.setState({ processing: true });
    this.editLead();
  }

  editLead() {
    const leadFields = { ...this.state.leadFields };
    this.props.editLead(leadFields, this.handleLedResponse);
  }

  // Rendering
  render() {
    return (
      <main>
        <h1>Solicitud de Garantía</h1>
        <p className="bajada">
          Completar los siguientes datos personales es importante para poder
          comenzar con la solicitud
        </p>
        <form ref={this._form}>
          <div className="middle-bar">
            <div className="middle-bar-content">
              <Row>
                <div className="combined-input col s12">
                  <p className="combined-input-label">Documento</p>
                  <div className="col input-field m4 s12">
                    <div className="react-select -padding-adjustment">
                      <FinaerSelect
                        selectedOption={this.state.leadFields.idType.value}
                        onChange={this.handleIdTypeChange}
                        placeholder="Tipo"
                        required={true}
                        options={Object.values(idDocuments)}
                      />
                    </div>
                  </div>
                  <Input
                    m={8}
                    s={12}
                    onChange={this.handleIdNumberChange}
                    label="Nro. de Documento"
                    value={this.state.leadFields.idNumber.value}
                    required={true}
                    maxLength={10}
                    error={this.errorMessageFor("idNumber")}
                  />
                </div>
              </Row>
              <Row>
                <div className="combined-input col m12 s12">
                  <p className="combined-input-label">Teléfono Celular</p>
                  <div className="m4 s12 input-with-prefix">
                    <Input
                      m={12}
                      s={12}
                      onChange={this.handlePhoneAreaCodeChange}
                      onKeyPress={this.handleEnterPress}
                      value={this.state.leadFields.phoneAreaCode.value}
                      required={true}
                      className="input-field"
                      label="Cód. de área"
                      placeholder="ej. 11"
                      minLength={2}
                      maxLength={4}
                      pattern="[0-9]*"
                      validate
                      error={this.errorMessageFor("phoneAreaCode")}
                    />
                    <span className="input-prefix">0</span>
                  </div>
                  <div className="m8 s12 input-with-prefix">
                    <span className="input-prefix">15</span>
                    <Input
                      m={12}
                      s={12}
                      onChange={this.handlePhoneNumberChange}
                      onKeyPress={this.handleEnterPress}
                      value={this.state.leadFields.phoneNumber.value}
                      required={true}
                      className="input-field"
                      label="Nro. de Celular"
                      placeholder="ej. 44445555"
                      minLength={6}
                      maxLength={10}
                      pattern="[0-9]*"
                      validate
                      error={this.errorMessageFor("phoneNumber")}
                    />
                  </div>
                </div>
              </Row>
              <p className="form-help-text">
                Ingresá tu número de celular sin el 0 y sin el 15
              </p>
            </div>
          </div>
          <div className="button-group">
            <LeftButton onClick={this.props.handlePrevious} />
            <Button
              className="round-btn"
              type="submit"
              onClick={this.nextButtonPressed}
              disabled={this.nextButtonShouldBeDisabled()}
            >
              {this.props.hasPrequalification
                ? "Confirmar"
                : "Avanzar para terminar"}
            </Button>
          </div>
        </form>
      </main>
    );
  }
}
